import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import BrandLogo from "@/components/BrandLogo";
import {
    LayoutDashboard, Tag, Layers, MessageSquare, Inbox, Mail,
    Settings as SettingsIcon, HelpCircle, LogOut, ExternalLink,
} from "lucide-react";

export default function AdminLayout() {
    const { logout, user } = useAuth();
    const { t } = useLang();

    const links = [
        { to: "/admin", label: t.admin.dashboard, Icon: LayoutDashboard, end: true },
        { to: "/admin/offers", label: t.admin.offers, Icon: Tag },
        { to: "/admin/categories", label: t.admin.categories, Icon: Layers },
        { to: "/admin/faqs", label: t.admin.faqs, Icon: HelpCircle },
        { to: "/admin/applications", label: t.admin.applications, Icon: Inbox },
        { to: "/admin/newsletter", label: t.admin.newsletterLeads, Icon: Mail },
        { to: "/admin/contact", label: t.admin.contactMessages, Icon: MessageSquare },
        { to: "/admin/settings", label: t.admin.settings, Icon: SettingsIcon },
    ];

    return (
        <div className="min-h-screen flex bg-brand-cream text-brand-charcoal">
            <aside className="hidden md:flex w-64 shrink-0 flex-col bg-brand-charcoal text-white" data-testid="admin-sidebar">
                <div className="px-5 py-6 border-b border-white/10">
                    <BrandLogo variant="light" />
                    <div className="mt-2 text-[10px] uppercase tracking-[0.25em] text-brand-yellow">Admin Panel</div>
                </div>
                <nav className="flex-1 py-4 px-3 space-y-1">
                    {links.map(({ to, label, Icon, end }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={end}
                            data-testid={`admin-nav-${to.split("/").pop() || "dashboard"}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition ${
                                    isActive ? "bg-white text-brand-charcoal font-semibold" : "text-white/75 hover:bg-white/10"
                                }`
                            }
                        >
                            <Icon className="h-4 w-4" /> {label}
                        </NavLink>
                    ))}
                </nav>
                <div className="px-3 py-4 border-t border-white/10">
                    <Link to="/" target="_blank" className="flex items-center gap-3 rounded-xl px-3 py-2 text-sm text-white/70 hover:bg-white/10">
                        <ExternalLink className="h-4 w-4" /> Website ansehen
                    </Link>
                    <button onClick={logout} data-testid="admin-logout" className="mt-1 w-full flex items-center gap-3 rounded-xl px-3 py-2 text-sm text-white/70 hover:bg-white/10">
                        <LogOut className="h-4 w-4" /> {t.admin.signOut}
                    </button>
                </div>
            </aside>

            <div className="flex-1 flex flex-col min-w-0">
                <header className="h-16 bg-white border-b border-black/5 flex items-center justify-between px-6">
                    <div className="text-sm text-brand-charcoal/60">Angemeldet als <b className="text-brand-charcoal">{user?.email}</b></div>
                    <div className="flex items-center gap-2 md:hidden">
                        <button onClick={logout} className="text-xs font-semibold text-brand-red">{t.admin.signOut}</button>
                    </div>
                </header>
                <main className="flex-1 overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
